/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { EventActionResourceReport } from "~/generated/graphql";

export type ResourceDetailsActionDetailsSidebarState = {
  resources?: EventActionResourceReport[];
  searchQuery?: string;
  filterQuery: ResourceDetailsActionDetailsSidebarFilterType;
};

export enum ResourceDetailsActionDetailsSidebarFilterType {
  ALL = "ALL",
  INSTALLED = "INSTALLED",
  UPDATED = "UPDATED",
  AVAILABLE = "AVAILABLE",
  REMOVED = "REMOVED",
  FAILED = "FAILED",
}
